/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'logout': {
    width: 16,
    height: 16,
    viewBox: '0 0 258.75 258.75',
    data: '<g><circle pid="0" cx="129.375" cy="60" r="60"/><path pid="1" d="M129.375 150c-60.061 0-108.75 48.689-108.75 108.75h217.5c0-60.061-48.689-108.75-108.75-108.75z"/></g>'
  }
})
